import { render, staticRenderFns } from "./CaseList.vue?vue&type=template&id=98b680bc"
import script from "./CaseList.vue?vue&type=script&lang=js"
export * from "./CaseList.vue?vue&type=script&lang=js"
import style0 from "./CaseList.vue?vue&type=style&index=0&id=98b680bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports